import { getCookie } from '@shared/cookie';
import LocalTracking from '@shared/tracking-local';
import { qtsHttpEndpoint } from 'server-data/tracking';
import { cookieBase, languageCode, cookieDomain } from 'server-data/flconfigs';
import QTSTracking from './qtslib';

_t = new QTSTracking(
  `${qtsHttpEndpoint}1px.gif`,
  cookieDomain,
  { user_id: getCookie(`${cookieBase}_USER_ID`) },
).init(_t);

_lt = new LocalTracking().init(_lt);

// Page view event
_t.push(['page_view', {
  screenHeight: window.screen.height,
  screenWidth: window.screen.width,
  windowInnerHeight: window.innerHeight,
  windowInnerWidth: window.innerWidth,
  language: languageCode,
}]);

// Latency
if (Math.random() < 0.01) {
  const startLatency = new Date().getTime();
  const request = new XMLHttpRequest();
  request.open('GET', '/pong.php', true);
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      _t.push(['latency', { latency: new Date().getTime() - startLatency }]);
    }
  };
  request.send();
}

// Navigation User Timings
function pushPagePerformanceTimings() {
  const pt = window.performance.timing;
  _t.push(['page_performance_timings', {
    navigationStart: pt.navigationStart,
    unloadEventStart: pt.unloadEventStart,
    unloadEventEnd: pt.unloadEventEnd,
    redirectStart: pt.redirectStart,
    redirectEnd: pt.redirectEnd,
    fetchStart: pt.fetchStart,
    domainLookupStart: pt.domainLookupStart,
    domainLookupEnd: pt.domainLookupEnd,
    connectStart: pt.connectStart,
    connectEnd: pt.connectEnd,
    responseStart: pt.responseStart,
    responseEnd: pt.responseEnd,
    domLoading: pt.domLoading,
    domInteractive: pt.domInteractive,
    domContentLoadedEventStart: pt.domContentLoadedEventStart,
    domContentLoadedEventEnd: pt.domContentLoadedEventEnd,
    domComplete: pt.domComplete,
    loadEventStart: pt.loadEventStart,
    loadEventEnd: Date.now(),
  }]);
}

if (window.performance) {
  if (document.readyState === 'complete') {
    pushPagePerformanceTimings();
  } else {
    window.addEventListener('load', pushPagePerformanceTimings, false);
  }
}

if (window.performance && window.performance.mark) {
  window.performance.mark('qts_ready');
}
